import AvataUpload from "components/AvataUpload";
import {
  Button,
  Col,
  Collapse,
  DatePicker,
  Form,
  FormInstance,
  Input,
  Modal,
  Row,
  Select,
  Space,
  Spin,
  Typography,
} from "antd";
import React, { FC, useEffect, useState } from "react";
import styled from "@emotion/styled";
import locale from "antd/es/date-picker/locale/th_TH";
import { EditOutlined } from "@ant-design/icons";
import { useGetAllCategory } from "hooks/useCategory";
import { AddressFacData, CategoryResponse } from "services/interface";
import SettingAvatar from "./SettingAvatar";
import FactoryAddress from "./FactoryAddress";
import MapGoogle from "components/GoogleMap";

const { Option } = Select;

const { Text } = Typography;

type Location = {
  lat: number;
  lng: number;
}

interface SettingFactoryFormProps {
  form: FormInstance;
  onFinish: (values: any) => void;
  avatar: any;
  address_fac: AddressFacData | undefined;
  location: Location;
  setLocation: (location: Location) => void;
}

const SettingFactoryForm: FC<SettingFactoryFormProps> = ({
  form,
  onFinish,
  avatar,
  address_fac,
  location,
  setLocation,
}) => {
  const [category, setCategory] = useState<CategoryResponse>([]);

  const { data, isLoading } = useGetAllCategory();

  const [open, setOpen] = useState(false);

  const showDrawer = () => {
    setOpen(true);
  };

  const onClose = () => {
    setOpen(false);
  };

  useEffect(() => {
    if (data) {
      setCategory(data);
    }
  }, [data]);

  const children: React.ReactNode[] = [];

  category.forEach((item) => {
    //children.push(<Option key={item.id}>{item.name}</Option>);
    if (item.childrens) {
      children.push(
        <Option key={item.id} value={item.id}>
          {item.name}
        </Option>
      );
      item.childrens.forEach((child) => {
        children.push(
          <Option key={child.id} value={child.id}>
            {child.name}
          </Option>
        );
        if (child.childrens) {
          child.childrens.forEach((child) => {
            children.push(
              <Option key={child.id} value={child.id}>
                {child.name}
              </Option>
            );
          });
        }
      });
    } else {
      children.push(
        <Option key={item.id} value={item.id}>
          {item.name}
        </Option>
      );
    }
  });

  return (
    <>
      {/* <WrapperAvata>
        <AvataUpload value={avatar} maximumUploadItems={1} />
      </WrapperAvata> */}
      {/*
        layout ตั้ง — ของเดิม labelCol 4 + wrapperCol 24 รวมกันเกิน 24 คอลัมน์ ป้ายจึงถูก
        บีบจนเหลือคำละบรรทัดและช่องกรอกล้นออกนอกกรอบเมื่อพื้นที่แคบ (เช่นตอนอยู่ใน dialog)
      */}
      <Form form={form} onFinish={onFinish} layout="vertical" size="large">
        {/*
          โลโก้อยู่ซ้าย ชื่อกิจการ+ที่อยู่อยู่ขวา — เรียงลงมาทั้งหมดจะยาวเกินกรอบ dialog
          จนต้องเลื่อนหาปุ่มบันทึก (จอเล็กค่อยตกลงมาเรียงกันเองด้วย xs={24})
        */}
        <Row gutter={24}>
          <Col xs={24} sm={8} style={{ textAlign: "center" }}>
            <SettingAvatar />
            <Typography.Text type="secondary" style={{ fontSize: 12 }}>
              โลโก้กิจการ
            </Typography.Text>
          </Col>

          <Col xs={24} sm={16}>
            <Form.Item
              name="name"
              label="ชื่อกิจการ"
              rules={[{ required: true, message: "กรุณากรอกชื่อกิจการ" }]}
            >
              <Input placeholder="ชื่อกิจการหรือแบรนด์ของคุณ" />
            </Form.Item>

            {/*
              อีเมลของบัญชีเจ้าของร้าน (user.email) — ไม่ใช่คอลัมน์ของ factory
              บันทึกแยกเส้นผ่าน update_contact_factory (ดู onFinish ใน index.tsx)
            */}
            <Form.Item
              name="email"
              label="อีเมล"
              rules={[
                { required: true, message: "กรุณากรอกอีเมล" },
                { type: "email", message: "รูปแบบอีเมลไม่ถูกต้อง" },
              ]}
            >
              <Input placeholder="example@email.com" maxLength={100} />
            </Form.Item>

            <FactoryAddress form={form} address_fac={address_fac} />
          </Col>
        </Row>

        {/*
          แผนที่พับไว้ — เป็นของที่ไม่ต้องแตะก็บันทึกได้ (พิกัดมีค่าเริ่มต้นอยู่แล้ว)
          และสูง ~50vh ซึ่งดันทุกอย่างที่เหลือตกจอเมื่อกางไว้ตลอด
        */}
        <Collapse
          ghost
          style={{ marginTop: 4 }}
          items={[
            {
              key: "location",
              label: <Typography.Text>ที่ตั้งกิจการบนแผนที่ (ไม่บังคับ)</Typography.Text>,
              children: (
                <Form.Item name="location" style={{ marginBottom: 0 }}>
                  <MapGoogle location={location} setLocation={setLocation} height="260px" />
                </Form.Item>
              ),
            },
          ]}
        />

        {/*
          ปุ่มเกาะก้นกรอบที่เลื่อน — ใน dialog กรอบนั้นคือกล่องเนื้อหา ส่วนในหน้าเต็ม
          คือหน้าจอ ทั้งสองที่จึงเห็นปุ่มตลอดโดยไม่ต้องเลื่อนไปหา
        */}
        <div
          style={{
            position: "sticky",
            bottom: 0,
            background: "#fff",
            borderTop: "1px solid #f0f0f0",
            padding: "12px 0 4px",
            marginTop: 8,
            textAlign: "center",
          }}
        >
          <Button
            style={{ width: "100%", maxWidth: 320 }}
            type="primary"
            size="large"
            htmlType="submit"
          >
            บันทึกข้อมูล
          </Button>
        </div>
      </Form>
    </>
  );
};

export default SettingFactoryForm;

const WrapperAvata = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  margin-bottom: 40px;
  width: 130px;
  height: auto;
  margin-left: auto;
  margin-right: auto;
`;
